var map = {
	"./learning-1.png": 91,
	"./learning-10.png": 92,
	"./learning-11.png": 93,
	"./learning-12.png": 94,
	"./learning-13.png": 95,
	"./learning-14.png": 96,
	"./learning-15.png": 97,
	"./learning-16.png": 98,
	"./learning-17.png": 99,
	"./learning-18.png": 100,
	"./learning-19.png": 101,
	"./learning-2.png": 102,
	"./learning-20.png": 103,
	"./learning-21.png": 104,
	"./learning-22.png": 105,
	"./learning-23.png": 106,
	"./learning-24.png": 107,
	"./learning-25.png": 108,
	"./learning-26.png": 109,
	"./learning-27.png": 110,
	"./learning-28.png": 111,
	"./learning-3.png": 112,
	"./learning-4.png": 113,
	"./learning-5.png": 114,
	"./learning-6.png": 115,
	"./learning-7.png": 116,
	"./learning-8.png": 117,
	"./learning-9.png": 118
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 308;